import { Component, OnInit } from '@angular/core';
// using reactive forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { data } from 'highcharts';
import { AuthService } from '../auth.service';
@Component({
  selector: 'app-ForgetPassword',
  templateUrl: './ForgetPassword.component.html',
  styleUrls: ['./ForgetPassword.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
    public ForgetPasswordForm: FormGroup;
    public submitted=false;
    public errtext="";
    public change=false;
   public email
  
    constructor(private formBuilder: FormBuilder, private router: Router,private authService: AuthService) {
    }
    ngOnInit(): void {
      this.email=localStorage.getItem("tempemail");
      localStorage.removeItem("tempemail");
        this.ForgetPasswordForm = this.formBuilder.group({
         
          password: ["",[Validators.required,Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*?[#?!@$%^&*-])[A-Za-z\d?=.*?[#?!@$%^&*-].{8,}'),Validators.minLength(8)]],
          confirmpassword:["",
              Validators.required
              ]},
              
              { validators: this.matchpasswordd })
  
             
            };


            get formControl() {
                return this.ForgetPasswordForm.controls;
              }
  
              get password(){
                return this.ForgetPasswordForm.get("password")
              }
             get confirmpassword(){
              return this.ForgetPasswordForm.get("confirmpassword")
              }
matchpasswordd(group: AbstractControl) {
    let pasword: string = group.get('password').value;
    let confirmPassword: string = group.get('confirmpassword').value;
    if (pasword.localeCompare(confirmPassword) != 0) {
        //error
        group.get('confirmpassword')?.setErrors({ mismatch: true });
            return { mismatch: true };
            } else {
            //no error, return null (don't return { mismatch: false })
             return null;
        }
     }
ChangePassword():void{
    if(this.ForgetPasswordForm.valid){
      
               this.authService.update(this.ForgetPasswordForm.get("password").value,this.email).subscribe(
                 data => {
                    console.log(data)
                    
                    this.change=true
                    this.errtext=" modification du mot de passe  avec succés !"
                      this.router.navigate(['/']);
           
                 },
                 error => {
                   console.log(error, 'error')
                   if (error.status == 401) {
                    this.errtext="Un probléme de changement de mot de passe, merci de contacter l'administrateur !"
                      
                   }
                  }
               );
        
  
       }
    
    }
                    
}


